import type { Application } from "@/lib/api/envoy";
// Imports nothing but types, so the sample (the API mock the synthetics run
// in Node) can hold its list to the same queue as the tabs.

/**
 * Where an application stands. Queue and applied are status tabs; an
 * untouched, skipped or closed one is only in All.
 */
export function statusGroup(
    application: Application | undefined,
): "queue" | "applied" | "open" | "closed" {
    if (!application) return "open";
    switch (application.status) {
        case "MATCHED":
            return application.queued_by ? "queue" : "open";
        case "TAILORING":
        case "NEEDS_YOU":
        case "FAILED":
            return "queue";
        case "APPLIED":
            return "applied";
        case "SKIPPED":
        case "CLOSED":
            return "closed";
    }
}
